import { Select, type SelectProps } from "./Select";

interface EnumSelectProps<T extends string> {
  value: T | null | undefined;
  options: readonly T[];
  onChange: (value: T) => void;
  formatLabel?: (value: T) => string;
  variant?: SelectProps["variant"];
  className?: string;
}

/** Typed wrapper around Select for string enum options. */
export function EnumSelect<T extends string>({
  value,
  options,
  onChange,
  formatLabel,
  variant = "default",
  className,
}: EnumSelectProps<T>) {
  const format =
    formatLabel ?? ((v: T) => v.charAt(0).toUpperCase() + v.slice(1));

  return (
    <Select
      variant={variant}
      className={className}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value as T)}
    >
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {format(opt)}
        </option>
      ))}
    </Select>
  );
}
